export default (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    if (d1.getTime() > d2.getTime()) {
        return 1;
    }
    if (d1.getTime() < d2.getTime()) {
        return -1;
    }
    return 0;
};



/** WEBPACK FOOTER **
 ** ./src/utils/compareDates.js
 **/